<template>
  <v-container v-if="dataset">
    <toolbar mode="dataset" :item="dataset" @clone="onClone" @delete="onDelete">
      <ax-button
        icon="mdi-api"
        tooltip="Copy APIs"
        :disabled="dataset.status !== 'SUCCESS'"
        @clicked="onCopyApis"
      />
      <ax-button
        v-if="isOwner(dataset)"
        fab
        small
        icon="mdi-refresh"
        confirm
        tooltip="Refresh"
        title="Reload data"
        subtitle="This will recreate the dataset from its original source files."
        depressed
        @confirmed="onUpdate"
      ></ax-button>
    </toolbar>
    <v-card flat>
      <v-tabs v-model="tab">
        <!-- <v-tab href="#data">Data</v-tab>
        <v-tab href="#info">Info</v-tab> -->
        <v-tab href="#details">Details</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <!-- <v-tab-item value="data">
          <frame-head :items="head"></frame-head>
        </v-tab-item>
        <v-tab-item value="info">
          <frame-info :items="info" />
        </v-tab-item> -->
        <v-tab-item value="details">
          <v-card-text>
            <v-container fluid class="pa-0">
              <v-row dense>
                <v-col cols="12" sm="2" md="1" class="font-weight-bold">Name</v-col>
                <v-col>{{ dataset.name }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="2" md="1" class="font-weight-bold">Files</v-col>
                <v-col>
                  <dl>
                    <dd v-if="dataset.completion">
                      <router-link :to="{ name: 'fileShow', params: { uuid: dataset.completion.uuid } }">
                        {{ dataset.completion.name }}
                      </router-link>
                    </dd>
                    <dd v-if="dataset.production">
                      <router-link :to="{ name: 'fileShow', params: { uuid: dataset.production.uuid } }">
                        {{ dataset.production.name }}
                      </router-link>
                    </dd>
                    <dd v-if="dataset.economic">
                      <router-link :to="{ name: 'fileShow', params: { uuid: dataset.economic.uuid } }">
                        {{ dataset.economic.name }}
                      </router-link>
                    </dd>
                  </dl>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="2" md="1" class="font-weight-bold">Filters</v-col>
                <v-col>
                  <template v-if="dataset.filters">
                    <v-chip v-for="(filter, index) in dataset.filters" :key="index" label small>
                      <template v-if="isObject(filter)">
                        {{ filter.column }} {{ filter.negation ? "not" : "" }} {{ filter.operator }}
                        {{ filter_value(filter) }}
                      </template>
                      <template v-else>{{ filter }}</template>
                    </v-chip>
                  </template>
                  <template v-else>
                    No filters
                  </template>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="2" md="1" class="font-weight-bold">Shape</v-col>
                <v-col>{{ dataset.shape[0] | numberFormat }} rows, {{ dataset.shape[1] | numberFormat }} columns</v-col>
              </v-row>
              <!-- <v-row dense>
                <v-col cols="12" sm="2" md="1" class="font-weight-bold">Columns</v-col>
                <v-col>
                  <v-chip class="mr-1 mb-1" v-for="column, i in dataset.columns" :key="i" small label outlined>{{ column }}</v-chip>
                </v-col>
              </v-row> -->
              <v-row dense>
                <v-col cols="12" sm="2" md="1" class="font-weight-bold">Owner</v-col>
                <v-col>{{ dataset.owner.name }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="2" md="1" class="font-weight-bold">Created</v-col>
                <v-col>{{ dataset.created_at | dateFormat("LL LT") }} ({{ dataset.created_at | dateFormat }})</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="2" md="1" class="font-weight-bold">Updated</v-col>
                <v-col>{{ dataset.updated_at | dateFormat("LL LT") }} ({{ dataset.updated_at | dateFormat }})</v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import toolbar from "@/components/toolbar"
import AxButton from "@/components/button"
import frameHead from "@/components/head"
import frameInfo from "@/components/info"
import Datasets from "@/api/datasets"
export default {
  name: "Dataset",
  components: {
    toolbar,
    frameHead,
    frameInfo,
    AxButton
  },
  data() {
    return {
      tab: "data",
      dataset: null,
    }
  },
  created() {
    Datasets.retrieve(this.$route.params.uuid).then(response => this.dataset = response.data)
  },
  methods: {
    filter_value(filter) {
      if (Array.isArray(filter.value)) {
        if (filter.value.length > 1) {
          return `(${filter.value.join(",")})`
        } else {
          return filter.value[0]
        }
      } else {
        return filter.value
      }
    },
    onUpdate() {
      Datasets.refresh(this.$route.params.uuid).then(response => this.notify(response.data))
    },
    onDelete() {
      Datasets.destroy(this.$route.params.uuid).then(_ => {
        this.notify('Dataset deleted')
        this.$router.push({ name: 'datasetList' })
      })
    },
    onClone(){
      Datasets.clone(this.$route.params.uuid).then(_ => {
        this.notify('Dataset cloned')
        this.$router.push({ name: 'datasetList' } )
      })
    },
    onCopyApis() {
      Datasets.apis(this.$route.params.uuid).then(response => {
        const apis = response.data
        if (apis && apis.length > 0) {
          const apisText = apis.join('\n')
          navigator.clipboard.writeText(apisText).then(() => {
            this.notify(`Copied ${apis.length} APIs to clipboard`)
          }).catch(err => {
            this.notify('Failed to copy to clipboard')
          })
        } else {
          this.notify('No APIs found')
        }
      }).catch(err => {
        this.notify('Failed to retrieve APIs')
      })
    }
  }
}
</script>
